import Communication from "pages/manage/ProfilePageResources/CommunicationBox/Communication";
import Notes from "../../../ProfilePageResources/NotesBox/Notes";
import { ParentLimitedResponse } from "client/openapi";

export default function NotesAndCommunicationTab({
  parent,
}: {
  parent: ParentLimitedResponse;
}) {
  return (
    <div className="grid grid-cols-1 gap-y-5 md:grid-cols-2 h-full">
      <div className="flex justify-center mx-5 mt-5 md:justify-end md:mx-0 md:mt-0">
        <Notes
          title="Internal Notes"
          parent={parent}
          toolTipMessage="These notes are private to this parent's profile."
        />
      </div>
      <div className="flex justify-center mx-5 mt-5 md:justify-end md:mx-0 md:mt-0">
        <Communication
          title="Communication"
          parent={parent}
          toolTipMessage="This represents inbound and outbound communication with this parent."
        />
      </div>
    </div>
  );
}
